<template>
    <div class="page my-order" :class="{ 'hide-tab': isHideTab }">
        <div class="tabber flex">
            <div
                class="tabber-item"
                :class="{ select: index == tabberIndex }"
                v-for="(item, index) in tabberList"
                :key="index"
                @click="changeTabber(index)"
            >
                {{ item.name }}
            </div>
        </div>
        <div class="order-list">
            <div
                class="order-item"
                v-for="(item, index) in orderList"
                :class="{ 'last-child': index + 1 == orderList.length }"
                :key="index"
                @click="toOrderInfo(item)"
            >
                <div class="session-info">
                    <img class="order-item-img" :src="item.pic" />
                    <div class="order-item-content">
                        <div class="film-name">
                            <span>{{ item.filmName }}</span>
                            <span
                                class="status"
                                :class="[
                                    { 'status-1': item.status == 5 && !item.supplierId },
                                    { 'status-2': item.status == 5 && item.supplierId },
                                    { 'status-3': item.status == 10 },
                                    { 'status-4': item.status == 15 },
                                ]"
                            >
                                {{ item.statusDesc }}
                            </span>
                        </div>
                        <div class="time">{{ item.movieInformation }}</div>
                        <div class="cinema-name">{{ item.cinemaName }}</div>
                        <div class="hall-name">{{ item.hallName }}</div>
                    </div>
                </div>
                <div class="dividing-line">
                    <div class="line-item"></div>
                </div>
                <div class="price-info">
                    <span>
                        优惠价
                        <span class="price">¥{{ item.totalPrice }}</span>
                    </span>
                    <span class="check" v-if="item.status == 10 || item.status == 15">
                        查看券码
                    </span>
                    <span class="check" v-else-if="item.status == 5">点击进入</span>
                    <img
                        class="status-img"
                        v-else-if="item.status == -5 && !item.paymentTime"
                        src="~@/assets/images/image-order-status--6.png"
                    />
                    <img
                        class="status-img"
                        v-else-if="item.status == -5"
                        src="~@/assets/images/image-order-status--5.png"
                    />
                    <img
                        class="status-img"
                        v-else-if="item.status == 15"
                        src="~@/assets/images/image-order-status-15.png"
                    />
                </div>
            </div>
            <div class="order-questions" v-if="orderList.length == 0" @click="showOrderQuestions">
                没有找到订单 ？
                <br />
                点击这里查看原因
                <img class="icon-tip" :src="require('@/assets/icons/icon-finger.png')" alt="" />
            </div>
            <Scroll :onBottom="onBottom" :lowerThreshold="200" />
        </div>
        <div class="footer">
            <span class="footer-text" v-if="isBottom">没有更多了</span>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Scroll from '@/components/scroll';
import { PAGE_ORDER_INFO, PAGE_ORDER_BID } from 'page';
import { GET_ORDER_LIST, SMS_GET_ORDER_LIST } from '@/api';
export default {
    data() {
        return {
            tabberList: [
                { name: '全部', status: '' },
                { name: '待支付', status: 0 },
                { name: '待出票', status: 5 },
                { name: '已出票', status: 10 },
                { name: '已取消', status: -5 },
            ],
            tabberIndex: 0,
            type: 0,
            pageIndex: 1,
            pageSize: 10,
            orderList: [],
            isBottom: false,
            isHideTab: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path != PAGE_ORDER_INFO) {
                vm.init();
            } else if (vm.orderList.length == 0) {
                vm.init();
            }
        });
    },
    components: {
        Scroll,
    },
    created() {},
    methods: {
        init() {
            this.type = this.$route.query.type;
            this.tabberIndex = this.type || 0;
            this.pageIndex = 1;
            this.orderList = [];
            this.getList();

            // 长空之王
            console.log(moment().format('x') < moment('2022-09-27 23:59:59').format('x'));
            if (moment().format('x') < moment('2022-09-27 23:59:59').format('x')) {
                this.$confirm.open({
                    title: '系统通知',
                    message:
                        '由于<span style="color:red;">《长空之王》</span>档期和上映计划的调整，若已购买<span style="color:red;">《长空之王》</span>的订单我们将在<span style="color:red;">9月27日(今天) 24时前</span>完成退款。',
                    confirmText: '退下吧',
                    hideCancelBtn: true,
                });
            }
        },
        // 显示提示文案
        showOrderQuestions() {
            this.$confirm.open({
                title: '温馨提示',
                message: `下单后如果没有找到订单，请确认是否是在<span style="font-weight:bold;padding:0 0.1rem;">所购买的平台</span>查看，比如在A平台购买，就要去A平台查订单，不能去B等其他平台查看。如果还是没找到请联系客服。`,
                confirmText: '知道了',
                cancelText: `<p style="color: #000000;">通过短信查询</p>`,
                // hideCancelBtn: true
                error: () => {
                    this.$confirm.close();
                    this.$smsVerify.open({
                        scene: 25,
                        success: smsVerifyRes => {
                            if (smsVerifyRes.success) {
                                this.smsGetOrderList(smsVerifyRes.data);
                            }
                        },
                    });
                },
            });
        },
        // 通过手机号方式获取订单列表
        smsGetOrderList(data) {
            this.$util.post(SMS_GET_ORDER_LIST, data).then(res => {
                if (res.success) {
                    this.$smsVerify.close();
                    this.isHideTab = true;
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        if (item.status == 5 && !item.supplierId) {
                            item.statusDesc = '排队中';
                        } else if (item.status == 5 && item.supplierId) {
                            item.statusDesc = '出票中';
                        }
                        item.movieInformation =
                            moment(item.showTime).format('YYYY.MM.DD HH:mm') +
                            ' ' +
                            item.versionTypes;
                    }
                    this.orderList = res.data;
                }
            });
        },
        // 获取订单列表
        getList(type = 0) {
            const { pageIndex, pageSize, tabberList, tabberIndex } = this;
            this.$util
                .post(GET_ORDER_LIST, {
                    pageIndex,
                    pageSize,
                    status: tabberList[tabberIndex].status,
                    grabBillStatus: tabberList[tabberIndex].grabBillStatus,
                })
                .then(res => {
                    if (res.success) {
                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            if (item.status == 5 && !item.supplierId) {
                                item.statusDesc = '排队中';
                            } else if (item.status == 5 && item.supplierId) {
                                item.statusDesc = '出票中';
                            }
                            item.movieInformation =
                                moment(item.showTime).format('YYYY.MM.DD HH:mm') +
                                ' ' +
                                item.versionTypes;
                        }
                        if (type == 1) {
                            this.orderList = res.data;
                        } else {
                            this.orderList = [...this.orderList, ...res.data];
                        }
                        if (this.orderList.length < res.total) {
                            this.isBottom = false;
                        } else {
                            this.isBottom = true;
                        }
                        this.orderList = this.$util.distinct(this.orderList, 'id');
                    }
                });
        },
        // 去订单列表
        toOrderInfo(item) {
            if (item.status == 0 && item.grabBillStatus == 5) {
                this.$util.pageJump(PAGE_ORDER_BID, {
                    orderNo: item.orderNo,
                });
            } else {
                this.$util.pageJump(PAGE_ORDER_INFO, {
                    orderNo: item.orderNo,
                    status: item.status,
                });
            }
        },
        // 类型切换
        changeTabber(index) {
            this.tabberIndex = index;
            this.pageIndex = 1;
            this.orderList = [];
            this.isBottom = true;
            this.getList(1);
        },
        // 触底事件
        onBottom() {
            if (this.isBottom) {
                return;
            }
            this.pageIndex++;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
@tabberHeight: .pxToRem(88) [];
.my-order {
    width: 100%;
    .tabber {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        font-size: .pxToRem(30) [];
        font-weight: 500;
        color: rgba(0, 0, 0, 0.5);
        height: @tabberHeight;
        line-height: @tabberHeight;
        background-color: #ffffff;
        justify-content: space-between;
        z-index: 10;
        .tabber-item {
            flex: 1;
            text-align: center;
            &.select {
                color: rgba(0, 0, 0, 0.9);
                &::after {
                    content: ' ';
                    .base-center-x;
                    bottom: .pxToRem(7) [];
                    .sq(10);
                    background: #f8c32f;
                    border-radius: 100%;
                }
            }
        }
    }
    .order-list {
        padding-top: calc(@tabberHeight + .pxToRem(20) []);
        box-sizing: border-box;
        min-height: calc(100vh - .pxToRem(96) []);
        .order-item {
            background-color: #ffffff;
            margin: 0 .pxToRem(30) [];
            margin-bottom: .pxToRem(20) [];
            border-radius: .pxToRem(40) [];
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
            .session-info {
                display: flex;
                padding: .pxToRem(30) [];
                align-items: flex-start;

                .order-item-img {
                    width: .pxToRem(160) [];
                    height: .pxToRem(210) [];
                    border-radius: .pxToRem(16) [];
                    margin-right: .pxToRem(30) [];
                    border-radius: .pxToRem(16) [];
                    overflow: hidden;
                }
                .order-item-content {
                    flex: 1;
                    color: rgba(159, 164, 178, 1);
                    line-height: .pxToRem(40) [];
                    .film-name {
                        display: flex;
                        line-height: .pxToRem(42) [];
                        font-size: .pxToRem(32) [];
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.9);
                        margin-bottom: .pxToRem(20) [];
                        justify-content: space-between;
                        align-items: top;
                        .status {
                            height: .pxToRem(32) [];
                            line-height: .pxToRem(32) [];
                            font-size: .pxToRem(28) [];
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.3);
                            // 排队中
                            &.status-1 {
                                color: #49c376;
                            }
                            // 出票中
                            &.status-2 {
                                color: #49c376;
                            }
                            // 已出票
                            &.status-3 {
                                color: #f7b500;
                            }
                            // 已完成
                            &.status-4 {
                                color: rgba(0, 0, 0, 0.9);
                            }
                        }
                    }
                    .time,
                    .cinema-name,
                    .hall-name {
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        color: rgba(0, 0, 0, 0.9);
                    }
                }
            }

            .dividing-line {
                height: .pxToRem(40) [];
                .line-item {
                    .base-center;
                    width: .pxToRem(630) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.15);
                }
                &::before {
                    content: ' ';
                    .base-center-y;
                    left: 0;
                    height: .pxToRem(36) [];
                    width: .pxToRem(18) [];
                    background: #ececec;
                    border-top-right-radius: .pxToRem(18) [];
                    border-bottom-right-radius: .pxToRem(18) [];
                }
                &::after {
                    content: ' ';
                    .base-center-y;
                    right: 0;
                    height: .pxToRem(36) [];
                    width: .pxToRem(18) [];
                    background: #eeeeee;
                    border-top-left-radius: .pxToRem(18) [];
                    border-bottom-left-radius: .pxToRem(18) [];
                }
            }
            .price-info {
                display: flex;
                padding: 0 .pxToRem(30) [] .pxToRem(16) [];
                justify-content: space-between;
                align-items: center;
                height: .pxToRem(84) [];
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.9);
                .price {
                    margin-left: .pxToRem(10) [];
                    font-size: .pxToRem(36) [];
                    font-weight: bold;
                }
                .check {
                    height: .pxToRem(60) [];
                    line-height: .pxToRem(60) [];
                    border: .pxToRem(1) [] solid #313131;
                    padding: 0 .pxToRem(22) [];
                    font-size: .pxToRem(26) [];
                    border-radius: .pxToRem(30) [];
                    box-sizing: border-box;
                }
                .status-img {
                    position: absolute;
                    bottom: .pxToRem(45) [];
                    right: .pxToRem(30) [];
                    .sq(160);
                }
            }
            &.last-child {
                margin-bottom: 0;
            }
        }
        .order-questions {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: .pxToRem(48) [];
            color: #d90209;
            line-height: .pxToRem(56) [];
            padding: .pxToRem(10) [] .pxToRem(20) [];
            border: .pxToRem(1) [] solid #d90209;
            border-radius: .pxToRem(8) [];
            white-space: nowrap;
            text-align: center;
            .icon-tip {
                position: absolute;
                bottom: .pxToRem(-20) [];
                right: .pxToRem(-20) [];
                transform: translate(100%, 100%);
                width: .pxToRem(96) [];
                height: .pxToRem(96) [];
                animation: moveTip 0.2s infinite;
            }
            @keyframes moveTip {
                0% {
                    bottom: .pxToRem(-20) [];
                    right: .pxToRem(-20) [];
                }
                50% {
                    bottom: .pxToRem(0) [];
                    right: .pxToRem(0) [];
                }
                100% {
                    bottom: .pxToRem(-20) [];
                    right: .pxToRem(-20) [];
                }
            }
        }
    }
    .footer {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        background-size: auto 1px;
        background-position: center;
        background-repeat: repeat-x;
        background-image: linear-gradient(0deg, #e3e5e9, #e3e5e9);
        height: .pxToRem(96) [];
        line-height: .pxToRem(96) [];
        font-size: .pxToRem(24) [];
        color: #999;
        &-text {
            padding: 0 .pxToRem(10) [];
            background-color: rgba(247, 249, 250, 1);
        }
    }
    &.hide-tab {
        .tabber {
            display: none;
        }
        .order-list {
            padding-top: calc(.pxToRem(20) []);
        }
    }
}
</style>
